// Signing on a number (+ || -), returns as a string
import { translate } from '../../locales';

const getSignedNumber = (n, onlyNumber = false) => {
  if (onlyNumber || n <= 0) {
    return n.toString();
  } else {
    return `+${n}`;
  }
};

const clampNumber = (num, min, max) => {
  return Math.min(Math.max(num, min), max);
};

const getTrendLabel = ({ badgeContent, showZero, min, max }) => {
  const clampedValue = clampNumber(badgeContent, min, max);
  // we are converting to a string, so we need to respect max and showZero
  if (clampedValue === 0 && !showZero) {
    // we need to hide zeros, we just wont convert to a string, MUI will handle that
    return clampedValue;
  }
  const signedNumber = getSignedNumber(clampedValue);
  return `${signedNumber}%`;
};

const getCounterLabel = ({ badgeContent, onlyNumber, min, max }) => {
  const clampedValue = clampNumber(badgeContent, min, max);
  return getSignedNumber(clampedValue, onlyNumber);
};

const getNotificationLabel = ({ badgeContent, min, max }) => {
  const clampedValue = clampNumber(badgeContent, min, max);
  return clampedValue;
};

const getNewLabel = ({ badgeContent }) => {
  if (badgeContent) {
    return badgeContent;
  }
  return translate('badge.new');
};

const getPremiumLabel = ({ badgeContent }) => {
  if (badgeContent) {
    return badgeContent;
  }

  return translate('badge.premium');
};

const getBetaLabel = ({ badgeContent }) => {
  if (badgeContent) {
    return badgeContent;
  }
  return translate('badge.beta');
};

const getComingSoonLabel = ({ badgeContent }) => {
  if (badgeContent) {
    return badgeContent;
  }
  return translate('badge.comingSoon');
};

const getCustomLabel = ({ badgeContent }) => badgeContent;

const getRecommendedLabel = ({ badgeContent }) => {
  if (badgeContent) {
    return badgeContent;
  }
  return translate('badge.recommended');
};

export const VARIANTS = {
  trend: getTrendLabel,
  counter: getCounterLabel,
  notification: getNotificationLabel,
  new: getNewLabel,
  premium: getPremiumLabel,
  beta: getBetaLabel,
  'coming-soon': getComingSoonLabel,
  custom: getCustomLabel,
  recommended: getRecommendedLabel
};
